export default __webpack_public_path__ + "static/media/JerzyWojcik_ponentes.0661da5d.png";